// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RemoteImage__wrapper-a5ff90 {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.RemoteImage__container-fa947e .RemoteImage__loader-c2ec08 {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 750ms;
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.RemoteImage__image-ad184a {
  opacity: 1;
  transition: opacity 750ms;
  vertical-align: top;
  border-radius: inherit;
}

.RemoteImage__is-loading-d33ae9 .RemoteImage__loader-c2ec08 {
  opacity: 1;
}

.RemoteImage__is-loading-d33ae9 .RemoteImage__image-ad184a {
  opacity: 0;
}

.RemoteImage__empty-src-b0afbb {
  background-color: var(--addition-190);
}

.RemoteImage__empty-src-b0afbb .RemoteImage__image-ad184a {
  visibility: hidden;
}

.RemoteImage__empty-src-b0afbb.RemoteImage__animated-reveal-fed6ea .RemoteImage__image-ad184a {
  visibility: visible;
  opacity: 0;
}

.RemoteImage__empty-src-b0afbb .RemoteImage__image-ad184a,
.RemoteImage__empty-src-b0afbb .RemoteImage__loader-c2ec08 {
  transition-duration: 0ms;
}`, "",{"version":3,"sources":["webpack://./../../packages/modules/src/remote-storage/components/RemoteImage/RemoteImage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,UAAA;AACF;;AAEA;;EAEE,wBAAA;AACF","sourcesContent":[".wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.container .loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  transition: opacity 750ms;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.image {\n  opacity: 1;\n  transition: opacity 750ms;\n  vertical-align: top;\n  border-radius: inherit;\n}\n\n.is-loading .loader {\n  opacity: 1;\n}\n\n.is-loading .image {\n  opacity: 0;\n}\n\n.empty-src {\n  background-color: var(--addition-190)\n}\n\n.empty-src .image {\n  visibility: hidden;\n}\n\n.empty-src.animated-reveal .image {\n  visibility: visible;\n  opacity: 0;\n}\n\n.empty-src .image,\n.empty-src .loader {\n  transition-duration: 0ms;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `RemoteImage__wrapper-a5ff90`,
	"container": `RemoteImage__container-fa947e`,
	"loader": `RemoteImage__loader-c2ec08`,
	"image": `RemoteImage__image-ad184a`,
	"is-loading": `RemoteImage__is-loading-d33ae9`,
	"isLoading": `RemoteImage__is-loading-d33ae9`,
	"empty-src": `RemoteImage__empty-src-b0afbb`,
	"emptySrc": `RemoteImage__empty-src-b0afbb`,
	"animated-reveal": `RemoteImage__animated-reveal-fed6ea`,
	"animatedReveal": `RemoteImage__animated-reveal-fed6ea`
};
module.exports = ___CSS_LOADER_EXPORT___;
